import { Pipe, PipeTransform } from '@angular/core';
import { StatusService } from '@bo-client/shared/status/status.service';

/** Bezeichnung des Auftragsstatus je Sparte eines Hausanschlusses (`Order.state`); unbekannt → Rohwert. */
@Pipe({
  name: 'orderState',
  pure: false
})
export class OrderStatePipe implements PipeTransform {
  constructor(private statusService: StatusService) {}
  transform(value: string) {
    return this.statusService.find('orders', value)?.displayName || value;
  }
}
